import { useGet } from '@/query/fetchHooks';
import { useState, useContext, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { nthLastIndexOf } from '@/util';
import { axios } from '@/axios';
import { config } from '@/config';
import { TrainingContent } from '@/components/LearningPath/Learn/TrainingContent';
import { NavContext } from '@/components/NavContext';
import { useTranslation } from 'react-i18next';
import { TEOLoader } from '@teo/components';

function TrainingLanding() {
  const { auth } = useContext(AuthContext);
  const navigate = useNavigate();
  const { setHeaderDisabled } = useContext(NavContext);
  const { trainingId } = useParams();
  const [training, setTraining] = useState<any>(null);
  const [followTraining, setFollowTraining] = useState<any>(null);
  const [teachers, setTeachers] = useState<any>(null);
  const [score, setScore] = useState<any>(0);
  const [myCertificate, setMyCertificate] = useState<any>(null);
  const [persons, setPersons] = useState<any>(null);
  const [institution, setInstitution] = useState<any>(null);
  const { t } = useTranslation();

  const originPath = window.location.pathname.slice(
    0,
    nthLastIndexOf(window.location.pathname, '/', 2)
  );

  useEffect(() => {
    setHeaderDisabled(true);
    return () => setHeaderDisabled(false);
  });

  useGet(`/training/${trainingId}`, {
    onSuccess: async (res: any) => {
      setTraining(res?.data || {});
    },
  });

  useGet(`/trainingfollow/${trainingId}/${auth?.user?.id}`, {
    retry: false,
    onSuccess: async (res: any) => {
      setFollowTraining(res?.data || null);
      setScore(Math.round(res?.data?.score * 100) || 0);
      setMyCertificate(
        res?.data?.certificates[0] ? res?.data?.certificates[0] : null
      );
    },
    onError: (res: any) => {
      console.error('res', res);
    },
  });

  useGet(`/trainingteachers`, {
    trainingId: trainingId,
    onSuccess: (res: any) => {
      setTeachers(res?.data || []);
    },
  });

  useGet(`/trainingcontacts`, {
    trainingId: trainingId,
    organisationId: `${auth?.user?.activeOrganisationId},OR,organisationId=null`,
    contactType: 'person',
    onSuccess: (res: any) => {
      setPersons(res?.data);
    },
  });

  useGet(`/contact/${training?.institutionId}`, {
    enabled: !!training?.institutionId,
    organisationId: `${auth?.user?.activeOrganisationId},OR,organisationId=null`,
    onSuccess: (res: any) => {
      setInstitution(res?.data);
    },
  });

  // const submitScore = async () => {
  //   console.log(1);
  //   const promisesNotifications: Promise<any>[] = [];
  //   for (const teach of teachers) {
  //     promisesNotifications.push(
  //       axios.post(`${config.backend}/notifications`, {
  //         text: {
  //           courseName: training?.trainingName,
  //         },
  //         type: 'tocorrect',
  //         globalLink: `/:lang/follow-up/:organisationId/correction/training/${trainingId}/${auth?.user?.id}`,
  //         userId: parseInt(teach?.id, 10),
  //         subject: trainingId,
  //       })
  //     );
  //   }

  //   const promises = [];
  //   promises.push(
  //     axios.put(
  //       `${config.backend}/trainingfollow/${followTraining?.trainingId}/${followTraining?.userId}`,
  //       {
  //         progress: 1,
  //         status: 'completed',
  //         score: score ? score / 100 : null,
  //         certificates: myCertificate ? [myCertificate] : [],
  //       }
  //     )
  //   );

  //   await Promise.allSettled(promises).then(() => {
  //     navigate(`${originPath}`);
  //   });
  // };
  const submitScore = async () => {
    try {
      for (const teach of teachers) {
        await axios.post(`${config.backend}/notifications`, {
          text: {
            courseName: training?.trainingName,
            username: auth?.user?.username,
          },
          type: 'tocorrect',
          globalLink: `/:lang/follow-up/:organisationId/correction/training/${trainingId}/${auth?.user?.id}`,
          userId: parseInt(teach?.id, 10),
          subject: trainingId,
        });
      }

      await axios.put(
        `${config.backend}/trainingfollow/${followTraining?.trainingId}/${followTraining?.userId}`,
        {
          progress: 1,
          status: 'completed',
          score: score ? score / 100 : null,
          certificates: myCertificate ? [myCertificate] : [],
        }
      );
      if (training?.learningpathId) {
        const nodegroup = await axios.get(
          `${config.backend}/nodegroups?type=training&objectId=${training?.id}&userId=${auth?.user?.id}`
        );

        if (nodegroup?.data[0]?.depth > 1) {
          navigate(`${originPath}/themes/${training?.learningpathId}`);
        } else {
          navigate(`${originPath}`);
        }
      }
    } catch (err) {
      console.error('Error in submitScore:', err);
    }
  };

  if (!followTraining) return null;
  if (!training) return null;

  return (
    <>
      {!training ? (
        <div className="fixed inset-0 z-[101] flex bg-white/75">
          <div className="m-auto">
            <TEOLoader
              loaderSrc="/images/TEOloader.gif"
              className="w-[120px]"
            />
          </div>
        </div>
      ) : (
        <div className="flex w-full flex-col ">
          <TrainingContent
            training={training}
            trainingId={trainingId}
            teachers={teachers}
            persons={persons}
            institution={institution}
            followTraining={followTraining}
            setScore={setScore}
            score={score}
            setMyCertificate={setMyCertificate}
            myCertificate={myCertificate}
            submitScore={submitScore}
            auth={auth}
            originPath={originPath}
          />
        </div>
      )}
    </>
  );
}

export default TrainingLanding;
